import { Component, OnInit } from '@angular/core';
import { BrandMaintenanceFilterComponent } from './brand-maintenance-filter/brand-maintenance-filter.component';
import { DialogService, LanguageService, HelperService } from 'src/app/services';
import { BrandMaintenanceService } from './brand-maintenance.service';
import { MAINTENANCE_BRAND_FOLDERNAME } from 'src/app/utils/constant';
import { environment } from 'src/environments/environment';
import { of as observableOf, Subscription } from 'rxjs';
import { MediaObserver } from '@angular/flex-layout';
import { catchError, finalize } from 'rxjs/operators';
import { requestBrand } from 'src/app/model/requests';
import { MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';

@Component({
  selector: 'esc-brand-maintenance',
  templateUrl: './brand-maintenance.component.html',
  styleUrls: ['./brand-maintenance.component.scss']
})

export class BrandMaintenanceComponent implements OnInit {
  public loading = {
    init: false,
    detail: false,
    more: false,
    export: false,
    import: false,
    error: false,
    detailError: false,
  }
  private listSub: Subscription;
  private detailSub: Subscription;
  public listData = [];
  public detailData;
  public columns = ["code", "description", "is_active"];
  public detailKeys = ["code", "description", "is_active"];
  public excelCols = ["BRAND CODE", "BRAND NAME", "STATUS"];
  private currentFilters;
  private previousFilters;
  public listLength = 0;
  public mode;
  public modifying: Boolean = false;
  public deselect: Boolean = false;
  networkErrMsg = this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {});
  public folderName = MAINTENANCE_BRAND_FOLDERNAME;

  constructor(
    public media: MediaObserver,
    private brandMntSvc: BrandMaintenanceService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    public helper: HelperService
  ) { }

  ngOnInit() {
    this.currentFilters = _.cloneDeep(requestBrand);
    this.getListData();
  }

  ngOnDestroy() {
    if (this.listSub && !this.listSub.closed) {
      this.listSub.unsubscribe();
    }
  }

  download(ev) {
    let dialogRef = this.dialogService.loading();
    this.listSub = this.brandMntSvc.genericMaintenanceDownload(this.currentFilters).pipe(
      finalize(() => {
        this.loading.init = false;
        this.loading.more = false;
        return observableOf(null);
      }),
      catchError((err) => {
        if (this.listData.length == 0) {
          this.loading.error = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
          this.currentFilters.web_filter.offset -= this.currentFilters.web_filter.limit;
        }
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (!res || res.status == 0 || res.status == 504 || res.status == 500) {
          this.loading.error = true;
          this.listData = [];
          this.listLength = 0;
          this.dialogService.openSnackBar(this.networkErrMsg);
          return;
        }
        if (_.has(res, 'value') && (_.toLower(res.value) == _.toLower("Success"))) {
          this.helper.openDownloadMenu(res.data);
          dialogRef.close();
        }
      });
  }
  
  getListData() {
    if (this.listSub && !this.listSub.closed) {
      this.listSub.unsubscribe();
    }
    if (this.loading.init == true) {
      return;
    }
    this.loading.error = false;
    if (this.listData.length == 0) {
      this.loading.init = true;
    } else {
      this.loading.more = true;
    }
    this.listSub = this.brandMntSvc.getList(this.currentFilters).pipe(
      finalize(() => {
        this.loading.init = false;
        this.loading.more = false;
        return observableOf(null);
      }),
      catchError((err) => {
        if (this.listData.length == 0) {
          this.loading.error = true;
        } else {
          this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_INTERNAL_SERVER_ERROR", {}));
          this.currentFilters.offset -= this.currentFilters.limit;
        }
        return observableOf(null);
      }))
      .subscribe((res: any) => {
        if (environment.showLogs) {
          console.log(res);
        }
        if (!res || res.status == 0 || res.status == 504 || res.status == 500) {
          this.loading.error = true;
          this.listData = [];
          this.listLength = 0;
          this.dialogService.openSnackBar(this.networkErrMsg);
          return;
        }
        if (_.has(res, 'value') && (_.toLower(res.value) == _.toLower("Success"))) {
          this.listData = this.listData.concat(res.data);
          this.listLength = _.toNumber(_.get(res, "count"));
        }
      });
  }

  getMore(event) {
    if (this.loading.more || this.loading.init || this.listData.length >= this.listLength) {
      return;
    }
    if (event) {
      this.currentFilters.web_filter.offset += this.currentFilters.web_filter.limit;
      this.getListData();
    }
  }

  getDetail(data) {
    if(data) {
      let temp = this.listData.filter(e => {
        return e.id == data.id;
      })
      this.detailData = _.clone(temp[0]);
      this.deselect = false;
    }
  }

  addNew(event) {
    this.closeDetail(null);
    this.modifying = true;
    this.mode = 'Add';
  }

  edit(event) {
    this.modifying = true;
  }

  searchBy(keyword) {
    this.currentFilters.web_filter.keyword = _.clone(keyword);
    this.refresh(true);
  }

  openFilter(ev) {
    let dialogRef: MatDialogRef<BrandMaintenanceFilterComponent>;
    dialogRef = this.dialogService.openDialog(BrandMaintenanceFilterComponent, {
      width: '500px',
      autoFocus: false,
      disableClose: false,
      data: _.get(this, 'previousFilters') || _.get(this, 'currentFilters')
    });
    dialogRef.afterClosed().subscribe((selectedFilters) => {
      if(selectedFilters) {
        this.previousFilters = _.cloneDeep(selectedFilters);

        this.currentFilters.web_filter.status =  _.get(selectedFilters, 'status.code');
        this.refresh(null);
      }
    })
  }

  saving(event) {
    this.loading.detail = true;
    if(_.has(event[0], 'code')) {
      let obj = _.get(event, '[0]');
      this.detailData = _.clone(obj);
    } 
    else if(!event) {
      this.loading.detail = false;
    }
  }

  closeDetail(event) {
    this.detailData = null;
    this.deselect = true;
  }

  closeForm(event) {
    this.modifying = false;
    this.mode = null;
    if(event) {
      this.refresh(event);
    }
  }

  refresh(event) {
    if (!event) {
      this.closeDetail(null);
    }
    this.listData = [];
    this.listLength = 0;
    this.currentFilters.web_filter.offset = _.clone(requestBrand.web_filter.offset);
    this.getListData();
  }
}